import { pickupOrdersTypes } from './actionTypes';

export const getPickupOrdersList = (payload: any) => {
  return {
    type: pickupOrdersTypes.GET_PICKUP_ORDERS,
    payload,
  }
};

export const getPickupOrdersSuccess = (payload: any) => ({
  type: pickupOrdersTypes.GET_PICKUP_ORDERS_SUCCESS,
  payload,
});

export const getPickupOrdersFail = (error: any) => ({
  type: pickupOrdersTypes.GET_PICKUP_ORDERS_FAIL,
  payload: error,
});

export const getMilestoneConfigPK = () => {
  return {
    type: pickupOrdersTypes.GET_MILESTONESCONFIG_PK,
  }
}

export const getMilestoneConfigPKSuccess = (payload: any) => {
  return {
    type: pickupOrdersTypes.GET_MILESTONESCONFIG_PK_SUCCESSS,
    payload,
  }
}

export const getMilestoneConfigPKFail = (payload: any) => {
  return {
    type: pickupOrdersTypes.GET_MILESTONESCONFIG_PK_FAIL,
    payload,
  }
}